module.exports = __webpack_public_path__ + "img/65_icon.1fa79124.png";